import React, { Component } from "react";
import styles from "./Footer.module.css";
import { useNavigate } from "react-router-dom";
function Footer() {
  return (
    <>
      <footer className={`${styles.footerSec}`}>
        <div className={`${styles.footerCont}`}>
          <div className={`${styles.footerSeg}`}>
            <h3 className={`${styles.footerTitle}`}>
              شرکت توسعه فناوری نوین افزار
              <span
                style={{
                  color: "red",
                  margin: 0,
                  marginRight: "5px",
                  fontSize: "1.6rem",
                }}>
                نیکان
              </span>
            </h3>
            <p>
              شرکت نیکان ، تولید کننده نرم افزار های تخصصی ردیابی خودرو و مدیریت
              ناوگان ، با قابلیت سفارشی سازی برای مشتری...
            </p>
            <p className={`${styles.footerAdd}`}>
              نشانی: تهران، شهرک راه آهن، میدان ساحل، مجتمع آرتمیس، بلوک T2 شرقی، طبقه
              ۵، واحد ۱
            </p>
          </div>
          <div className={`${styles.footerSeg}`}>
            <h3 className={`${styles.footerTitle}`}>منو سایت</h3>
            <a href="/">خانه</a>
            <a href="/Products">محصولات</a>
            <a href="/Profile">پروفایل</a>
            <a href="https://www.raahyab.com" target="_blank">
              راهیاب
            </a>
          </div>
          <div className={`${styles.footerSeg}`}>
            <h3 className={`${styles.footerTitle}`}>راه های ارتباطی</h3>

            <span>فروش و خدمات: 09216388036</span>
            <span>ایمیل: info@tfnn.ir</span>
            <span
              className={`${styles.aparatSpan}`}
              onClick={(e) =>
                window.open("https://www.aparat.com/TfnNikan", "_blank")
              }>
              کانال آپارات: Tfn Nikan
            </span>
            <span>پشتیبانی نرم‌افزار: 09216388036</span>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
